module.exports = __webpack_public_path__ + "static/img/carousel_fbt.1064a42.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/carousel_fbt.png
// module id = LTUB
// module chunks = 0